/**
 * Handle redirects for legacy URLs that no longer exist
 */
const REDIRECTS = {
  '/websites/mobile': '/websites/apps',
};

export default ({ route, redirect }) => {
  const targetPath = REDIRECTS[route.path];

  if (targetPath) {
    redirect(301, targetPath);
  }
};
